import * as React from 'react';
import { BASE_URL } from '../../../../config/environmentConfig';
import { ON_BOARDING_ROUTES } from '../../../utils/constatns';
import {
  getFormattedSignUpFormField,
  getStripeFormattedSignUpFormField
} from '../../../constants/sign-up/sign-up-form';
import { IAction } from '../merchant-interfaces';
import { merchantActionTypes } from '../action-types';
import { executeRecaptcha } from '../../../views/login/Login';
import { POST } from '../../store-helper';
import { ILink } from '../../../interfaces/links';

export const setSignUp = async (
  dispatch: React.Dispatch<IAction>,
  formik: any,
  handleSuccess: (links?: ILink[]) => void,
  handleDecline?: () => void,
  isStripe?: boolean,
): Promise<void> => {
  console.log('setSignUp', formik);
  if (!formik.isValid) return;
  try {
    dispatch({ type: merchantActionTypes.SET_SIGN_UP_LOADING, payload: true });
    const recaptchaToken = await executeRecaptcha();
    const body = isStripe ?
        getStripeFormattedSignUpFormField(formik.values) :
        getFormattedSignUpFormField(formik.values);
    body.recaptchaToken = recaptchaToken;
    const response = await POST({
      pathname: isStripe ?
          `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/stripe-signup` :
          `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/signup`,
      body,
      formik,
    });

    console.log('setSignUp', response);

    handleSuccess(response?.links);
    dispatch({ type: merchantActionTypes.SET_SIGN_UP_LOADING, payload: false });
  } catch (e) {
    dispatch({ type: merchantActionTypes.SET_SIGN_UP_LOADING, payload: false });
    console.log('setSignUp', e.response?.data);

    if (handleDecline) {
      handleDecline();
    }
  }
};
